import React, { Component } from "react";
import { ButtonToolbar, Table, Grid, Label } from 'react-bootstrap';

import { LoadingSpinner } from '../../LoadingSpinner';
import { SortIndicator } from '../../SortIndicator';
import { PaginationBuilder } from '../../PaginationBuilder';
import { SearchHelper } from '../../helpers/SearchHelper';
import { ComparisonHelper } from '../../helpers/ComparisonHelper';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { TableButton } from '../../TableButton';

export class LinesActive extends Component {
    constructor(props) {
        super(props);

        this.state = {
            render: {
                sort: {
                    property: "code",
                    type: "ascending"
                }
            }
        }
    }

    // -----------------------

    onChangeSort(property) {
        const { render } = this.state;

        render.sort.type = render.sort.property === property && "ascending" === render.sort.type ? "descending" : "ascending";
        render.sort.property = property;

        this.setState({
            render: render
        });
    }

    // -----------------------

    sortLines(sort, a, b) {
        let aValue = a[sort.property];
        let bValue = b[sort.property];

        if ("object" === typeof aValue) {
            aValue = undefined !== aValue.left ? aValue.left : aValue.right;
        }

        if ("object" === typeof bValue) {
            bValue = undefined !== bValue.left ? bValue.left : bValue.right;
        }

        if(aValue === bValue) {
            return 0;
        }

        const output = aValue < bValue ? -1 : 1;

        if("descending" === sort.type) {
            return output * -1;
        }

        return output;
    }

    // -----------------------

    renderTakeoverButton(selectedProvider, line) {
        if (undefined === selectedProvider) {
            return null;
        }

        return (
            <TableButton marginRight icon="icon-select" title="Alterar Controlo" onClick={() => this.props.onTakeoverClick(line)} />
        );
    }

    renderControl(controlledByTA) {
        if (controlledByTA) {
            return (<Label bsStyle="success" className="icon-ok icon-img">&nbsp;</Label>)
        }
        else {
            return null;
        }
    }

    renderColor(color, attribute) {
        if (undefined === color || null === color) {
            return null;
        }

        return (
            <span className="span-colors"
                style={
                    { backgroundColor: `rgba(${color[attribute].r}, ${color[attribute].g}, ${color[attribute].b}, ${color[attribute].a})` }
                }
            />
        );
    }

    renderLoading(isLoading) {
        if(isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderSortIndicator(property, sort) {
        if(property !== sort.property) {
            return (
                <SortIndicator order="none" />
            );
        }

        return (
            <SortIndicator order={sort.type} />
        );
    }

    render() {
        const { render } = this.state;
        const { selectedProvider, lines, isLoading, currentPage, 
            elementsPerPage, isComparing, filter } = this.props;
        
        let linesFiltered;
        if (isComparing) {
            const { draftLines } = this.props;

            linesFiltered = SearchHelper.search({
                filter: filter,
                data: ComparisonHelper.compare(
                    lines,
                    draftLines || [],
                    {
                        match: [{ left: "code", right: "code" }],
                        fields: [{ left: "extCode", right: "externalCode" }, { left: "goName", right: "goName" }, { left: "returnName", right: "returnName" }]
                    }),
                fields: ["code", "code.left", "code.right", "extCode", "extCode.left", "extCode.right", "goName", "goName.left", "goName.right", "returnName", "returnName.left", "returnName.right"]
            });
        }
        else {
            linesFiltered = SearchHelper.search({
                filter: filter,
                data: lines,
                fields: ["code", "extCode", "goName", "returnName"]
            });
        }

        const totalPages = PaginationHelper.getTotalPages(linesFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const linesToRender = linesFiltered.sort((a, b) => this.sortLines(render.sort, a, b))
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                <div className="table-loading">
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th className="width-10p sortable" onClick={() => this.onChangeSort("code")}>Código {this.renderSortIndicator("code", render.sort)}</th>
                                <th className="width-10p sortable" onClick={() => this.onChangeSort("extCode")}>Código Externo {this.renderSortIndicator("extCode", render.sort)}</th>
                                <th className="width-20p sortable" onClick={() => this.onChangeSort("goName")}>Nome de Ida {this.renderSortIndicator("goName", render.sort)}</th>
                                <th className="width-20p sortable" onClick={() => this.onChangeSort("returnName")}>Nome de Volta {this.renderSortIndicator("returnName", render.sort)}</th>
                                <th className="width-10p">Cor Fundo </th>
                                <th className="width-10p">Cor Texto</th>
                                <th className="width-10p">Controlada por AT</th>
                                <th className="width-10p">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody className={isLoading ? "overlay" : ""}>
                            {
                                linesToRender.map((line, idx) =>
                                    <tr key={`line-${idx}`} className={ComparisonHelper.getRowClass(line.code)}>
                                        <td>{ComparisonHelper.renderProperty(line.code)}</td>
                                        <td>{ComparisonHelper.renderProperty(line.extCode)}</td>
                                        <td>{ComparisonHelper.renderProperty(line.goName)}</td>
                                        <td>{ComparisonHelper.renderProperty(line.returnName)}</td>
                                        <td>{this.renderColor(line.lineColor, "backColor")}</td>
                                        <td>{this.renderColor(line.lineColor, "foreColor")}</td>
                                        <td>{this.renderControl(line.controlledByTA)}</td>
                                        <td>
                                            <ButtonToolbar className="pull-right">
                                                {this.renderTakeoverButton(selectedProvider, line)}
                                                <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditClick(line)} />
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteClick(line)} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>

                    <PaginationBuilder
                        currentPage={activePage}
                        elementsPerPage={elementsPerPage}
                        dataLength={linesFiltered.length}
                        onChangePage={(a) => this.props.onChangePage(a)}
                        onChangeElementsPerPage={(a) => this.props.onChangeElementsPerPage(a)} />

                    {this.renderLoading(isLoading)}
                </div>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/lines/LinesActive.js